/* eslint-disable no-unused-expressions */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import './CompanyAutoComplete.css';
import { toast } from 'react-toastify';
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import Comments from './DragNDrop/Comments';
import Comment from './DragNDrop/Comment';
class MultiSelectPriDropdown extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      selectedCompanyArray: [],
      dropdownList: props.dropdownList,
      tempList: props.dropdownList,
      suggestions: this.filterCompanies(searchTerm),
      clearList: props.clearList || false,
    };
  }

  componentDidMount() {
    const { initialList } = this.props;
    if (initialList?.length > 0) {
      this.setInitialSelectedCompanyGroup();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }
    if (this.props.clearList !== prevProps.clearList) {
      this.setState({ selectedCompanyArray: [], searchTerm: '' });
    }
  }

  filterCompanies = value => {
    const inputValue = value.trim().toLowerCase();
    const { dropdownList, filterTag } = this.props;
    return dropdownList.filter(item => {
      return item[filterTag].toLowerCase().includes(inputValue);
    });
  };

  getCompanyValue = item => item[this.props.filterTag];

  renderSuggestion = item => <div>{item[this.props.filterTag]}</div>;

  onChange = (event, { newValue }) => {
    const { MultiSelect } = this.props;
    if (!MultiSelect && newValue === '') {
      this.props.onChange({ name: this.props.nameTag, value: null, suggestion: null });
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterCompanies(value),
    });
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  setInitialSelectedCompanyGroup = async () => {
    const { selectedCompanyArray } = this.state;
    const { dropdownList: suggestion, onChange, initialList } = this.props;

    const _shallowClone = [...selectedCompanyArray, ...initialList];
    await this.setState({ selectedCompanyArray: _shallowClone });
    await onChange(_shallowClone);
  };

  resetInitialSelectedCompanyGroup = async () => {
    const { onChange } = this.props;
    const EMPTY_ARRAY = [];
    await this.setState({ selectedCompanyArray: EMPTY_ARRAY });
    await onChange(EMPTY_ARRAY);
  };

  onCompanySelected = async (ev, { suggestion, suggestionValue }) => {
    const { selectedCompanyArray } = this.state;
    const { onChange, MultiSelect } = this.props;

    if (MultiSelect) {
      const extractSerialNumber = selectedCompanyArray?.map(item => item.serialNumber);
      const existSerialNumber = suggestion.serialNumber;
      if (extractSerialNumber.length > 0 && extractSerialNumber.includes(existSerialNumber)) {
        toast.error('Sorry, Already added in the list');
      } else {
        selectedCompanyArray.push(suggestion);
        this.setState({ selectedCompanyArray, searchTerm: '' });
        onChange(selectedCompanyArray);
      }
    } else {
      const evObj = { name: this.props.nameTag, value: suggestionValue, suggestion };
      this.props.onChange(evObj);
    }
  };

  onKeyPress = e => {
    if (e.key === 'Enter') {
      const { dropdownList, userAutocomplete, filterTag } = this.props;
      const suggestion = dropdownList.filter(item => item[filterTag] === e.currentTarget.value);
      this.props.onChange({
        name: this.props.nameTag,
        value: e.currentTarget.value,
        suggestion: { ...suggestion[0] },
      });
    }
  };

  onCardRemove = (index) => {
    const { selectedCompanyArray } = this.state;
    const { onChange } = this.props;
    const duplicateList = [...selectedCompanyArray];
    duplicateList.splice(index, 1);
    this.setState({ selectedCompanyArray: duplicateList });
    onChange(duplicateList);
  };

  dragEnded = param => {
    const { source, destination } = param;
    const { selectedCompanyArray } = this.state;
    const { onChange } = this.props;
    
    if (!destination) {
      return;
    }

    let _arr = [...selectedCompanyArray];
    //extracting the source item from the list
    const _item = _arr.splice(source.index, 1)[0];
    //inserting it at the destination index.
    _arr.splice(destination.index, 0, _item);
    onChange(_arr)
    this.setState({ selectedCompanyArray: _arr });
  }

  renderSelectedCompany = () => {
    const { selectedCompanyArray } = this.state;
    return (
      <div className='mt-3'>
        <DragDropContext onDragEnd={(param) => this.dragEnded(param)}>
          <Droppable droppableId="comments-wrapper">
            {(provided, snapshot) => (
              <Comments ref={provided.innerRef} {...provided.droppableProps}>
                {selectedCompanyArray.map((_comment, index) => {
                  return (
                    <Draggable
                      draggableId={`comment-${_comment._id}`}
                      index={index}
                      key={_comment._id}
                    >
                      {(_provided, _snapshot) => (
                        <Comment
                          ref={_provided.innerRef}
                          dragHandleProps={_provided.dragHandleProps}
                          {..._provided.draggableProps}
                          snapshot={_snapshot}
                          {..._comment}
                          index={index}
                          removeItem={this.onCardRemove}
                        />
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </Comments>
            )}
          </Droppable>
        </DragDropContext>
      </div>
    );
  };

  render() {
    const { searchTerm, suggestions, selectedCompanyArray } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: this.props.placeholder || 'Search Item...',
      disabled: selectedCompanyArray.length === 3,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: this.props.nameTag,
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={this.props.className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getCompanyValue}
          renderSuggestion={this.renderSuggestion}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onCompanySelected}
        />
        {selectedCompanyArray.length > 0 && (
          <div className="email-list">{this.renderSelectedCompany()}</div>
        )}
      </div>
    );
  }
}

export default MultiSelectPriDropdown;
